import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@xingternal/button';
import { IconHomeFilled } from '@xingternal/icons';
import { ArrowIcon } from '@/components/ArrowIcon';
import styles from './Breadcrumbs.css';
import { getCrumbs } from '@/routes/getCrumbs';
import type { Crumb } from '@/routes/getCrumbs';
import type { BreadcrumbsType } from '@/routes/Router';
import { useIntl } from 'react-intl';

const isLastCrumb = ({ crumbs, key }: { crumbs: Crumb[]; key: number }) =>
  key + 1 === crumbs.length;

const Breadcrumbs = ({
  routes,
  match,
}: {
  routes: BreadcrumbsType[];
  match: any;
}) => {
  const intl = useIntl();

  const crumbs: Crumb[] = getCrumbs({ routes, match, intl });

  return (
    <div className={styles.container}>
      <Button className={styles.home} href={'/'}>
        <IconHomeFilled width={16} height={16} />
      </Button>
      {crumbs.map(({ name, path }, key) => (
        <div className={styles.breadcrumb} key={path}>
          <ArrowIcon direction={'right'} className={styles.arrow} />
          {isLastCrumb({ crumbs, key }) ? (
            <span className={styles.last} key={key}>
              <>{name}</>
            </span>
          ) : (
            <Link className={styles.link} key={key} to={path}>
              <>{name}</>
            </Link>
          )}
        </div>
      ))}
    </div>
  );
};

export { Breadcrumbs };
